import { z } from 'zod';

export const UMErrorSchema = z.object({
  message: z.string().optional(),
  slug: z.string().optional(),
});

export const MedtechColandarErrorSchema = z.object({
  status: z.string(),
  errors: z
    .object({
      location: z.string(),
      name: z.string(),
      description: z.string().optional(),
    })
    .array(),
});

export type UMErrorType = z.infer<typeof UMErrorSchema>;
export type MedtechColandarError = z.infer<typeof MedtechColandarErrorSchema>;
